import type { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { Spinner } from '~/components/ui/spinner'
import { useAuthStore } from '~/stores/auth-store'

// 인증 가드(세션 기반). 세션 확인은 App이 마운트 시 한 번 트리거한다. 확인 전(unknown)에는
// 로딩을 보여주고, 미인증이면 로그인으로 보낸다. knoka 콜백이 `/admin/?auth_error=forbidden`로
// 되돌린 경우 그 쿼리를 로그인 화면까지 보존해 안내가 뜨도록 한다.
export function RequireAdmin({ children }: { children: ReactNode }) {
    const status = useAuthStore((s) => s.status)
    const location = useLocation()

    if (status === 'unknown') {
        return (
            <div className='bg-background flex h-screen items-center justify-center'>
                <Spinner label='세션 확인 중' />
            </div>
        )
    }
    if (status === 'unauthenticated') {
        const authError = new URLSearchParams(location.search).get('auth_error')
        const to = authError
            ? `/login?auth_error=${encodeURIComponent(authError)}`
            : '/login'
        return <Navigate to={to} replace />
    }
    return <>{children}</>
}
